export const publicUrl = process.env.NEXT_PUBLIC_URL!
export const gaMeasurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID!
